import { render } from "./Reorder.vue?vue&type=template&id=00f6261b"
import script from "./Reorder.vue?vue&type=script&lang=ts"
export * from "./Reorder.vue?vue&type=script&lang=ts"
script.render = render

export default script